import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveComWixpressBookingsReaderV2BookingsReaderUrl(opts) {
    const domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'editor._base_domain': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
            {
                srcPath: '/bookings/bookings-reader',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Retrieves a list of bookings, including additional extended information, given the provided paging, filtering, and sorting.
 *
 * Up to 100 extended bookings can be returned per request.
 *
 * `queryExtendedBookings()` runs with these defaults, which you can override:
 *
 * - `createdDate` sorted in `DESC` order
 * - `cursorPaging.limit` is `50`
 *
 *
 * You can retrieve information about which actions the customer can perform
 * for the bookings. To do so, pass `withBookingAllowedActions` as `true`.
 *
 *
 * For field support, see
 * [supported filters](https://www.wix.com/velo/reference/wix-bookings-v2/extendedbookings/supported-filters)
 * for more information.
 *
 * You can specify a filter only once per query. If you specify a filter
 * more than once, only the first filter determines the extended bookings that are returned.
 *
 * When filtering by date, you must use [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 */
export function queryExtendedBookings(payload) {
    function __queryExtendedBookings({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.reader.v2.extended_booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.reader.v2.BookingsReader.QueryExtendedBookings',
            url: resolveComWixpressBookingsReaderV2BookingsReaderUrl({
                protoPath: '/v2/extended-bookings/query',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'extendedBookings.booking.createdDate' },
                        { path: 'extendedBookings.booking.startDate' },
                        { path: 'extendedBookings.booking.endDate' },
                        { path: 'extendedBookings.booking.updatedDate' },
                        { path: 'extendedBookings.booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'extendedBookings.booking.contactDetails.fullAddress.geocode.latitude',
                        },
                        {
                            path: 'extendedBookings.booking.contactDetails.fullAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __queryExtendedBookings;
}
//# sourceMappingURL=bookings-reader-v2-extended-booking-extended-bookings.http.js.map